import { render, staticRenderFns } from "./RPIEpenalties.vue?vue&type=template&id=09db2044&scoped=true&"
import script from "./RPIEpenalties.vue?vue&type=script&lang=js&"
export * from "./RPIEpenalties.vue?vue&type=script&lang=js&"
import style0 from "./RPIEpenalties.vue?vue&type=style&index=0&id=09db2044&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09db2044",
  null
  
)

export default component.exports